import { Routes } from '@angular/router';
import { ForcedProfileUpdateGuard } from '@app/core/guards/force-profile-update/forced-profile-update.guard';

export const MEMBERS_ROUTES: Routes = [
  {
    path: '',
    loadComponent: () => import('./member-page/member-page.component')
      .then(m => m.MemberPageComponent),
    canActivate: [ForcedProfileUpdateGuard],
  },
];

